// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pac-container:empty {
  display: none !important;
}

img[src*=icon_error] {
  display: none !important;
}

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.231372549);
  border-radius: 10px;
}

.outlined-text-field {
  position: relative;
}
.outlined-text-field .MuiInputLabel-root {
  font-size: 14px;
  color: #14151C;
  -webkit-transform: none;
  transform: none;
  position: relative;
}
.outlined-text-field .MuiInputBase-root.Mui-error {
  color: #d32f2f;
}
.outlined-text-field .MuiInputBase-root {
  background-color: #fff;
}
.outlined-text-field .MuiInputBase-root input[type=text].MuiInputBase-input {
  color: #696F88;
  font-size: 14px;
  padding: 8px 12px;
}
.outlined-text-field .MuiInputBase-root input[type=text].MuiInputBase-input.MuiInputBase-inputAdornedEnd {
  font-size: 14px;
}
.outlined-text-field .MuiInputBase-root input[type=text]::placeholder {
  color: #696F88;
}
.outlined-text-field .MuiInputAdornment-root {
  cursor: pointer;
}
.outlined-text-field .MuiInputAdornment-root .MuiInputBase-root {
  height: 37px !important;
}
.outlined-text-field .MuiInputAdornment-root.MuiInputAdornment-positionStart {
  border-right: 1px solid #ccc;
  height: 46px;
  padding-right: 15px;
  margin: 0px;
}
.outlined-text-field input:-webkit-autofill,
.outlined-text-field input:-webkit-autofill:hover,
.outlined-text-field input:-webkit-autofill:focus,
.outlined-text-field ::-webkit-scrollbar {
  width: 100%;
}
.outlined-text-field input:-webkit-autofill,
.outlined-text-field input:-webkit-autofill:hover,
.outlined-text-field input:-webkit-autofill:focus,
.outlined-text-field input:-webkit-autofill:active {
  -webkit-background-clip: text;
  -webkit-text-fill-color: #696F88;
  transition: background-color 5000s ease-in-out 0s;
  box-shadow: inset 0 0 20px 20px #fff;
}

textarea,
.MuiInputBase-inputMultiline {
  font-size: 14px !important;
  color: #696F88;
  font-family: inherit;
}

.select-dropdown .MuiInputBase-formControl .MuiSelect-select {
  font-size: 14px;
  color: #696F88;
}
.select-dropdown .MuiAutocomplete-root .MuiFormControl-root .MuiInputBase-formControl {
  font-size: 14px;
  color: #696F88;
  height: 37px;
  background-color: #fff;
  padding: 0px 9px;
}
.select-dropdown .Mui-error {
  margin: 0px;
}
.select-dropdown .error {
  color: #D84315;
}

.search_feild .MuiInputBase-colorPrimary {
  background-color: #FFFFFF;
  border: 1px solid #E2E7EB;
  border-radius: 8px;
  padding: 3px 6px;
  height: 37px;
}
.search_feild .MuiInputBase-colorPrimary::before {
  border-style: none !important;
}
.search_feild .MuiInputBase-colorPrimary::after {
  border-style: none !important;
}
.search_feild .MuiInputBase-colorPrimary svg {
  padding-left: 5px;
}
.search_feild .MuiInputBase-colorPrimary input {
  font-size: 14px;
  color: #696F88 !important;
}
.search_feild .MuiInputBase-colorPrimary input::placeholder {
  color: #696F88 !important;
  opacity: 0.9;
  letter-spacing: 0.1px;
  font-size: 14px;
}

.date-container .date-picker-styles {
  margin: 0px !important;
}
.date-container .date-picker-styles .MuiInputBase-input {
  padding: 8px 12px;
  font-size: 14px;
  color: #696F88;
}
.date-container .date-picker-styles .MuiInputBase-root .MuiOutlinedInput-notchedOutline {
  border-color: #A3A9B9;
}
.date-container .MuiFormControl-root .clear-date {
  display: none;
}
.date-container .MuiFormControl-root:hover .clear-date {
  display: block;
  position: absolute;
  right: 36px !important;
  background: transparent;
  bottom: 0px;
}
.date-container .MuiFormControl-root .MuiStack-root {
  width: 100%;
  overflow: inherit;
  padding-top: 0px;
}

.btn-txt {
  text-transform: capitalize !important;
  padding: 5px !important;
}

.btn-txt-capitalize {
  text-transform: capitalize !important;
}

.reset_password {
  color: #232630;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
  padding-top: 32px;
}
.reset_password ul li {
  margin: 5px 0px;
}
.reset_password ul li svg {
  position: relative;
  top: 5px;
  margin-left: 5px;
  font-size: 17px;
}

.email-password-success-header {
  color: black;
  font-size: 24px;
  font-weight: 400;
  line-height: 32px;
  word-wrap: break-word;
  padding-bottom: 16px;
  align-items: flex-start;
}

.email-password-success-content {
  color: #696F88;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  word-wrap: break-word;
  padding-bottom: 32px;
}

.filtr-date-pkr .MuiStack-root {
  overflow: hidden;
}
.filtr-date-pkr .MuiStack-root .MuiTypography-root {
  font-size: 14px;
}

.custom-select-container .mui-selector {
  height: 40px;
}
.custom-select-container .mui-selector .MuiSelect-select p {
  font-size: 14px;
  color: #696F88;
}
.custom-select-container .mui-selector .MuiSelect-select {
  font-size: 14px;
  color: #696F88;
  padding: 9.5px 14px;
}

.filtr-search .MuiInputBase-root .MuiOutlinedInput-input {
  padding: 8px 14px;
}

.MuiPopover-paper .MuiMenu-list .select-lebel-text {
  font-size: 14px;
}

.message-error {
  height: 20%;
  top: 8px;
  max-width: 400px;
  left: 38% !important;
  right: 20% !important;
}

.disable-fields {
  opacity: 0.5;
  cursor: not-allowed;
}

.common-module-wrapper.admin-management-wrapper .module-common-table-wrapper .MuiTableContainer-root {
  max-height: calc(100vh - 200px);
}

.common-module-wrapper.backlog-table-section .module-common-table-wrapper .module-table-root.backlog-table-fixed-height {
  height: calc(100vh - 273px);
  display: flex;
  flex-direction: column;
}
.common-module-wrapper.backlog-table-section .module-common-table-wrapper .module-table-root.backlog-table-fixed-height .MuiTableContainer-root.table-component {
  flex: 1;
  max-height: none !important;
  margin-bottom: 0;
}
.common-module-wrapper.backlog-table-section .module-common-table-wrapper .module-table-root.backlog-table-fixed-height > .MuiStack-root {
  padding: 10px 0;
}

.common-module-wrapper .module-common-table-wrapper {
  margin: 0px 16px;
}
.common-module-wrapper .module-common-table-wrapper ::-webkit-scrollbar {
  height: 0px;
}
.common-module-wrapper .module-common-table-wrapper .MuiTableContainer-root {
  margin-bottom: 10px;
  box-sizing: border-box;
}
.common-module-wrapper .module-common-table-wrapper .MuiTableContainer-root .MuiTable-root .MuiTableHead-root .MuiTableRow-root th {
  font-size: 16px;
  white-space: nowrap;
  background-color: #00375c;
}
.common-module-wrapper .module-common-table-wrapper .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .MuiTableRow-root p {
  font-size: 14px;
}
.common-module-wrapper .module-common-table-wrapper .MuiTableContainer-root .MuiTable-root .MuiTableBody-root tr {
  height: 47px;
}
.common-module-wrapper .module-common-table-wrapper .MuiTableContainer-root .MuiTable-root .MuiTableBody-root tr td {
  padding: 7px 14px;
  max-width: 180px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.common-module-wrapper .module-common-table-wrapper .MuiTableContainer-root .MuiTable-root .MuiTableBody-root tr td .MuiIconButton-root {
  padding: 0px 8px;
}
.common-module-wrapper .module-common-table-wrapper .MuiTableContainer-root .MuiTable-root .MuiTableBody-root .no-data-text .MuiTableCell-root {
  border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/form_styles.scss","webpack://./src/assets/scss/variable.scss"],"names":[],"mappings":"AAMI;EACI,wBAAA;AALR;;AAUA;EACI,wBAAA;AAPJ;;AAUA;EACI,UAAA;EACA,WAAA;AAPJ;;AAUA,UAAA;AACA;EACI,uBAAA;AAPJ;;AAUA,WAAA;AACA;EACI,sCAAA;EACA,mBAAA;AAPJ;;AAWA;EACI,kBAAA;AARJ;AAUI;EACI,eAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AARR;AAYQ;EACI,cAAA;AAVZ;AAQI;EAKI,sBAAA;AAVR;AAaY;EACI,cAAA;EACA,eAAA;EACA,iBAAA;AAXhB;AAagB;EACI,eC5BV;ADiBV;AAeY;EACI,cC3DH;AD8Cb;AA4BI;EACI,eAAA;AA1BR;AA4BQ;EACI,uBAAA;AA1BZ;AA6BQ;EACI,4BAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;AA3BZ;AA+BI;;;;EAII,WAAA;AA7BR;AAgCI;;;;EAII,6BAAA;EACA,gCCrGK;EDsGL,iDAAA;EACA,oCAAA;AA9BR;;AAmCA;;EAEI,0BAAA;EACA,cAAA;EACA,oBAAA;AAhCJ;;AAqCQ;EACI,eC5FF;ED6FE,cCvHC;ADqFb;AAyCY;EACI,eCrGN;EDsGM,cChIH;EDiIG,YAAA;EACA,sBAAA;EACA,gBAAA;AAvChB;AA4CI;EACI,WAAA;AA1CR;AA6CI;EACI,cC1IA;AD+FR;;AAiDI;EACI,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AA9CR;AAgDQ;EACI,6BAAA;AA9CZ;AAiDQ;EACI,6BAAA;AA/CZ;AAkDQ;EACI,iBAAA;AAhDZ;AAmDQ;EACI,eAAA;EACA,yBAAA;AAjDZ;AAoDY;EACI,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AAlDhB;;AAyDI;EACI,sBAAA;AAtDR;AAwDQ;EACI,iBAAA;EACA,eCjKF;EDkKE,cC5LC;ADsIb;AA0DY;EACI,qBCnMH;AD2Ib;AA8DQ;EACI,aAAA;AA5DZ;AAgEY;EACI,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;AA9DhB;AAkEQ;EACI,WAAA;EACA,iBAAA;EACA,gBAAA;AAhEZ;;AAsEA;EACI,qCAAA;EACA,uBAAA;AAnEJ;;AAsEA;EACI,qCAAA;AAnEJ;;AAsEA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;AAnEJ;AAsEQ;EACI,eAAA;AApEZ;AAsEY;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;AApEhB;;AA0EA;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;EACA,uBAAA;AAvEJ;;AA0EA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,oBAAA;AAvEJ;;AA2EI;EACI,gBAAA;AAxER;AA0EQ;EACI,eAAA;AAxEZ;;AA8EI;EACI,YAAA;AA3ER;AA8EY;EACI,eCtQN;EDuQM,cCjSH;ADqNb;AAyEQ;EAMI,eC1QF;ED2QE,cCrSC;EDsSD,mBAAA;AA5EZ;;AAmFQ;EACI,iBAAA;AAhFZ;;AAuFQ;EACI,eC5RF;ADwMV;;AAyFA;EACI,WAAA;EACA,QAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;AAtFJ;;AA+FA;EACI,YAAA;EACA,mBAAA;AA5FJ;;AA2GQ;EACI,+BAAA;AAxGZ;;AAiHQ;EACI,2BAAA;EACA,aAAA;EACA,sBAAA;AA9GZ;AAgHY;EACI,OAAA;EACA,2BAAA;EACA,gBAAA;AA9GhB;AAiHY;EACI,eAAA;AA/GhB;;AAwHI;EACI,gBAAA;AArHR;AA2HQ;EACI,WAAA;AAzHZ;AA4HQ;EACI,mBAAA;EAGA,sBAAA;AA5HZ;AAiIwB;EACI,eAAA;EACA,mBAAA;EACA,yBC9XX;AD+PjB;AAsIwB;EACI,eAAA;AApI5B;AAwIoB;EACI,YAAA;AAtIxB;AAwIwB;EACI,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AAtI5B;AAwI4B;EACI,gBAAA;AAtIhC;AA8IwB;EACI,mBAAA;AA5I5B","sourcesContent":["@import './mixins.scss';\n@import './variable.scss';\n\n.pac-container {\n    // Created empty when a lookup fails. Left visible it is an invisible\n    // overlay that blocks typing in the field underneath.\n    &:empty {\n        display: none !important;\n    }\n}\n\n\nimg[src*=\"icon_error\"] {\n    display: none !important;\n}\n\n::-webkit-scrollbar {\n    width: 4px;\n    height: 4px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n    background: #0000003b;\n    border-radius: 10px;\n}\n\n// outlined text field\n.outlined-text-field {\n    position: relative;\n\n    .MuiInputLabel-root {\n        font-size: 14px;\n        color: #14151C;\n        -webkit-transform: none;\n        transform: none;\n        position: relative;\n    }\n\n    .MuiInputBase-root {\n        &.Mui-error {\n            color: #d32f2f;\n        }\n\n        background-color: #fff;\n\n        input[type=\"text\"] {\n            &.MuiInputBase-input {\n                color: #696F88;\n                font-size: 14px;\n                padding: 8px 12px;\n\n                &.MuiInputBase-inputAdornedEnd {\n                    font-size: $font_14;\n                }\n            }\n\n            &::placeholder {\n                color: $input_text;\n            }\n        }\n    }\n\n    .MuiFormHelperText-root {\n        // margin-top: 0px;\n\n        // &.Mui-error {\n        //     position: absolute;\n        //     bottom: -22px;\n        // }\n    }\n\n\n    .MuiInputAdornment-root {\n        cursor: pointer;\n\n        .MuiInputBase-root {\n            height: 37px !important;\n        }\n\n        &.MuiInputAdornment-positionStart {\n            border-right: 1px solid #ccc;\n            height: 46px;\n            padding-right: 15px;\n            margin: 0px;\n        }\n    }\n\n    input:-webkit-autofill,\n    input:-webkit-autofill:hover,\n    input:-webkit-autofill:focus,\n    ::-webkit-scrollbar {\n        width: 100%;\n    }\n\n    input:-webkit-autofill,\n    input:-webkit-autofill:hover,\n    input:-webkit-autofill:focus,\n    input:-webkit-autofill:active {\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: $input_text;\n        transition: background-color 5000s ease-in-out 0s;\n        box-shadow: inset 0 0 20px 20px #fff;\n    }\n}\n\n// Style for all textarea elements in forms (including MUI TextField multiline)\ntextarea,\n.MuiInputBase-inputMultiline {\n    font-size: 14px !important;\n    color: #696F88 ;\n    font-family: inherit;\n}\n\n.select-dropdown {\n    .MuiInputBase-formControl {\n        .MuiSelect-select {\n            font-size: $font_14;\n            color: $input_text;\n            // background-color: #fff;\n        }\n    }\n\n    .MuiAutocomplete-root {\n        .MuiFormControl-root {\n            .MuiInputBase-formControl {\n                font-size: $font_14;\n                color: $input_text;\n                height: 37px;\n                background-color: #fff;\n                padding: 0px 9px;\n            }\n        }\n    }\n\n    .Mui-error {\n        margin: 0px;\n    }\n\n    .error {\n        color: $error;\n    }\n}\n\n// search field\n.search_feild {\n    .MuiInputBase-colorPrimary {\n        background-color: #FFFFFF;\n        border: 1px solid #E2E7EB;\n        border-radius: 8px;\n        padding: 3px 6px;\n        height: 37px;\n\n        &::before {\n            border-style: none !important;\n        }\n\n        &::after {\n            border-style: none !important;\n        }\n\n        svg {\n            padding-left: 5px;\n        }\n\n        input {\n            font-size: 14px;\n            color: #696F88 !important;\n            // text-transform: lowercase;\n\n            &::placeholder {\n                color: #696F88 !important;\n                opacity: 0.9;\n                letter-spacing: 0.1px;\n                font-size: 14px;\n            }\n        }\n    }\n}\n\n.date-container {\n    .date-picker-styles {\n        margin: 0px !important;\n\n        .MuiInputBase-input {\n            padding: 8px 12px;\n            font-size: $font_14;\n            color: $input_text;\n        }\n\n        .MuiInputBase-root {\n            .MuiOutlinedInput-notchedOutline {\n                border-color: $grey_color;\n            }\n        }\n    }\n\n    .MuiFormControl-root {\n        .clear-date {\n            display: none;\n        }\n\n        &:hover {\n            .clear-date {\n                display: block;\n                position: absolute;\n                right: 36px !important;\n                background: transparent;\n                bottom: 0px;\n            }\n        }\n\n        .MuiStack-root {\n            width: 100%;\n            overflow: inherit;\n            padding-top: 0px;\n        }\n    }\n\n}\n\n.btn-txt {\n    text-transform: capitalize !important;\n    padding: 5px !important;\n}\n\n.btn-txt-capitalize {\n    text-transform: capitalize !important;\n}\n\n.reset_password {\n    color: #232630;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    word-wrap: break-word;\n    padding-top: 32px;\n\n    ul {\n        li {\n            margin: 5px 0px;\n\n            svg {\n                position: relative;\n                top: 5px;\n                margin-left: 5px;\n                font-size: 17px;\n            }\n        }\n    }\n}\n\n.email-password-success-header {\n    color: black;\n    font-size: 24px;\n    font-weight: 400;\n    line-height: 32px;\n    word-wrap: break-word;\n    padding-bottom: 16px;\n    align-items: flex-start;\n}\n\n.email-password-success-content {\n    color: #696F88;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 20px;\n    word-wrap: break-word;\n    padding-bottom: 32px;\n}\n\n.filtr-date-pkr {\n    .MuiStack-root {\n        overflow: hidden;\n\n        .MuiTypography-root {\n            font-size: 14px;\n        }\n    }\n}\n\n.custom-select-container {\n    .mui-selector {\n        height: 40px;\n\n        .MuiSelect-select {\n            p {\n                font-size: $font_14;\n                color: $input_text;\n            }\n\n            font-size: $font_14;\n            color: $input_text;\n            padding: 9.5px 14px;\n        }\n    }\n}\n\n.filtr-search {\n    .MuiInputBase-root {\n        .MuiOutlinedInput-input {\n            padding: 8px 14px;\n        }\n    }\n}\n\n.MuiPopover-paper {\n    .MuiMenu-list {\n        .select-lebel-text {\n            font-size: $font_14;\n        }\n    }\n}\n\n.message-error {\n    height: 20%;\n    top: 8px;\n    max-width: 400px;\n    left: 38% !important;\n    right: 20% !important;\n}\n\n// .date-container{\n//     .MuiTypography-root{\n//         color: red;\n//     }\n// }\n\n.disable-fields {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n// this style removed for overriding the revamp styles \n// .MuiStack-root {\n//     .MuiButtonBase-root {\n//         .MuiTypography-root {\n//             font-size: 16px;\n//         }\n//     }\n// }\n\n\n\n.common-module-wrapper.admin-management-wrapper {\n    .module-common-table-wrapper {\n        .MuiTableContainer-root {\n            max-height: calc(100vh - 200px);\n        }\n\n    }\n\n}\n\n.common-module-wrapper.backlog-table-section {\n    .module-common-table-wrapper {\n        .module-table-root.backlog-table-fixed-height {\n            height: calc(100vh - 273px);\n            display: flex;\n            flex-direction: column;\n\n            .MuiTableContainer-root.table-component {\n                flex: 1;\n                max-height: none !important;\n                margin-bottom: 0;\n            }\n\n            > .MuiStack-root {\n                padding: 10px 0;\n            }\n        }\n\n    }\n\n}\n\n.common-module-wrapper {\n    .module-common-table-wrapper {\n        margin: 0px 16px;\n\n        ::-webkit-scrollbar-thumb {\n            // background: #55585f;\n        }\n\n        ::-webkit-scrollbar {\n            height: 0px;\n        }\n\n        .MuiTableContainer-root {\n            margin-bottom: 10px;\n            // max-height: calc(100vh - 263px);\n            //  padding: 0px 16px;\n            box-sizing: border-box;\n\n            .MuiTable-root {\n                .MuiTableHead-root {\n                    .MuiTableRow-root {\n                        th {\n                            font-size: 16px;\n                            white-space: nowrap;\n                            background-color: $blueShades_11;\n                        }\n                    }\n                }\n\n                .MuiTableBody-root {\n                    .MuiTableRow-root {\n                        p {\n                            font-size: 14px;\n                        }\n                    }\n\n                    tr {\n                        height: 47px;\n\n                        td {\n                            padding: 7px 14px;\n                            max-width: 180px;\n                            text-overflow: ellipsis;\n                            overflow: hidden;\n                            white-space: nowrap;\n\n                            .MuiIconButton-root {\n                                padding: 0px 8px;\n                            }\n                        }\n                    }\n\n                    .no-data-text {\n                        // height: 66vh;\n\n                        .MuiTableCell-root {\n                            border-bottom: none;\n                        }\n                    }\n                }\n            }\n        }\n\n    }\n}","// Color codes\n$primary_color: #232630;\n$grey_color: #A3A9B9;\n$light_black: #14151C;\n$input_text: #696F88;\n$light_bgcolor: #F3F4F6;\n$color: #A3A9B9;\n$error: #D84315;\n$white_color: #fff;\n$light_background: #F3F4F6;\n$light_border_color: #C2C7D0;\n$label_color: #808080;\n$border_color: #DFE2E7;\n$white: #fff;\n$link_blue: #1976E7;\n$gey_shades_11:#F7F7F7;\n$gey_shades_12:#DADADA;\n$gey_shades_13: #9E9E9E;\n$gey_shades_14: #4F4F4F;\n$gey_shades_15: #848484;\n$gey_shades_16: #A6A6A6;\n$gey_shades_17:#F9F9F9;\n$blueShades_11 : #00375c;\n$blueShades_12 : #1F275C;\n\n// Font sizes   \n$font_10: 10px;\n$font_11: 11px;\n$font_12: 12px;\n$font_13: 13px;\n$font_14: 14px;\n$font_15: 15px;\n$font_16: 16px;\n$font_18: 18px;\n$font_20: 20px;\n$font_21: 21px;\n$font_22: 22px;\n$font_24: 24px;\n$font_25: 25px;\n$font_26: 26px;\n$font_28: 28px;\n$font_29: 29px;\n$font_30: 30px;\n\n// Font weights\n$font_weight_normal: normal;\n$font_weight_bold: bold;\n$font_weight_medium: Medium;\n$font_weight_300: 300;\n$font_weight_500: 500;\n$font_weight_600: 600;\n$font_weight_700: 700;\n\n// Font Family\n// $robot: 'robotoregular';\n\n// Box shadow\n$box_shadow_1: 0 1px 3px 0 rgba(63, 63, 68, 0.15),\n    0 0 0 1px rgba(63, 63, 68, 0.05);\n$box_shadow_2: 0 0 7px 0 rgba(0, 0, 0, 0.23);\n$box_shadow_3: 0 0 6px 0 rgba(0, 0, 0, 0.27);\n$box_shadow_4: 0 0 0 1px #e4e7eb;\n$box_shadow_5: 0 0 15px 0 rgba(0, 0, 0, 0.23);\n$box_shadow_1: 0 4px 6px 0 rgba(0, 0, 0, 0.06);\n$box_shadow: 2px 4px 16px rgba(50, 98, 149, 0.15);\n\n//Border radius\n$border_4: 4px;\n$border_10: 10px;\n$border_15: 15px;\n$border_100: 100%;\n\n///margin scss \n//------------------\n$margin-5: 5px 5px 5px 5px;\n$margin-10: 10px 10px 10px 10px;\n$margin-15: 15px 15px 15px 15px;\n$margin-10-15: 10px 15px 10px 15px;\n\n//Media quries\n$mobile_breakpoint: 576px;\n$tablet_breakpoint: 768px;\n$laptop_breakpoint: 992px;\n$large_laptop_breakpoint: 1280px;\n$desktop_breakpoint: 1440px;\n$desktop_point: 1024px;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
